module.exports = __webpack_public_path__ + "img/carblue.9934337c.png";